import { AppLifecyclePhase, RefsixState } from "../models/refsixState";
import {
    SET_LIFECYCLE_PHASE,
    USER_LOGGED_IN,
    USER_LOGOUT,
} from "../actions/types";
import { Middleware } from "redux";
import { startDatabase } from "../../services/matchService";
import { setLifecyclePhase } from "../actions/appLifecycle";

export const startDatabaseMiddleware: Middleware<{}, RefsixState> =
    (store) => (next) => (action) => {
        let shouldStart = false;
        let newLogin = false;

        switch (action.type) {
            case USER_LOGGED_IN:
                const currentAuth = store.getState().auth.session;

                newLogin = action.session && !currentAuth;
                shouldStart = true;

                break;

            case USER_LOGOUT:
                // Let the root reducer reset state first, then transition
                // to UNAUTHENTICATED so the UI immediately shows auth screens.
                // Use next() instead of store.dispatch() to avoid re-entering
                // the full middleware chain, which causes issues with
                // redux-persist state tracking during the reset.
                next(action);
                next(setLifecyclePhase(AppLifecyclePhase.UNAUTHENTICATED));
                return;

            case "persist/REHYDRATE":
                // After rehydration, transition directly to STARTING_DATABASE
                next(action);

                const rehydratedAuth = action.payload?.auth;
                if (rehydratedAuth?.loggedIn && rehydratedAuth?.session) {
                    store.dispatch(
                        setLifecyclePhase(
                            AppLifecyclePhase.STARTING_DATABASE
                        )
                    );
                    startDatabase(false);
                } else {
                    store.dispatch(
                        setLifecyclePhase(AppLifecyclePhase.UNAUTHENTICATED)
                    );
                    // Receipt-driven username pre-fill orchestration is
                    // owned by Root in route/index.tsx — it fires once
                    // when the lifecycle first enters UNAUTHENTICATED on
                    // cold-start, matching the sibling getProfile effect
                    // for the authenticated branch.
                }
                return;

            case SET_LIFECYCLE_PHASE:
                // Pass through lifecycle phase changes
                break;
        }

        next(action);

        if (shouldStart) {
            store.dispatch(
                setLifecyclePhase(AppLifecyclePhase.STARTING_DATABASE)
            );
            startDatabase(newLogin);
        }
    };
